import { requestApi } from '../util/network'

export const getUserInfo =
() =>
  requestApi(
    '/o2o_distributor_user/get_info',
    'POST',
    {
    },
    'distributor'
  )
export const getUserStatistics =
() =>
  requestApi(
    '/o2o_distributor_user/get_statistics',
    'POST',
    {
    },
    'distributor'
  )
export const updateUserReceipt =
(receipt) =>
  requestApi(
    '/o2o_distributor_user/update_receipt',
    'POST',
    {
      receipt: receipt
    },
    'distributor'
  )
export const updateUserSet =
(new_ring, new_shock, urge_ring, urge_shock, receipt_limit, auto_receipt) =>
  requestApi(
    '/o2o_distributor_user/update_set',
    'POST',
    {
      new_ring: new_ring,
      new_shock: new_shock,
      urge_ring: urge_ring,
      urge_shock: urge_shock,
      receipt_limit: receipt_limit,
      auto_receipt: auto_receipt
    },
    'distributor'
  )
export const updateUserMobile =
(password, mobile, verifyCode) =>
  requestApi(
    '/o2o_distributor_user/update_mobile',
    'POST',
    {
      password: password,
      mobile: mobile,
      verify_code: verifyCode
    },
    'distributor'
  )
export const updateUserEmail =
(password, email) =>
  requestApi(
    '/o2o_distributor_user/update_email',
    'POST',
    {
      password: password,
      email: email
    },
    'distributor'
  )
export const updateUserPassword =
(password1, password2, verifyCode) =>
  requestApi(
    '/o2o_distributor_user/update_password',
    'POST',
    {
      password1: password1,
      password2: password2,

      verify_code: verifyCode
    },
    'distributor'
  )

export const updateUserInformation =
(realname, introduce, regionId, regionName) =>
  requestApi(
    '/o2o_distributor_user/update_information',
    'POST',
    {
      realname: realname,
      introduce: introduce,
      region_id: regionId,
      region_name: regionName
    },
    'distributor'
  )
export const uploadUserFile =
(file) =>
  requestApi(
    '/o2o_distributor_user/upload_file',
    'POST',
    file,
    'distributor',
    true
  )
export const updateUserPaymentAccount =
(payment_account) =>
  requestApi(
    '/o2o_distributor_user/update_payment_account',
    'POST',
    {
      payment_account: payment_account
    },
    'distributor'
  )
export const updateUserErrandDeposit =
    () =>
      requestApi(
        '/o2o_distributor_user/update_errand_deposit',
        'POST',
        {

        },
        'distributor'
      )
